module.exports = __webpack_public_path__ + "img/score-ar.5ed44919.png";